import { gotoCustom } from '@/components/Grid/cells/actions'

export default {
  get: function () {
    let model = {
      'PaymentInvoiceId': '_',
      'InvoiceNumber': {
        label: 'Invoice',
        width: 120,
        getter: getInvoiceNumberPDFLink
      },
      MediaCode: {
        label: 'Attachment',
        width: 100,
        getter: getAttachmentPDF
      },
      'InitialTotalAmount': {
        label: 'Initial Amount',
        width: 110
      },
      'FinalAmount': {
        label: 'Amount',
        width: 110
      },
      Scanner: {
        label: 'Scanned by',
        width: 120
      },
      Reviewer: {
        label: 'Reviewer',
        type: 'text',
        width: 110
      },
      Client: {
        label: 'Client',
        width: 160
      },
      Planner: {
        label: 'Submitted By',
        width: 130
      },
      Created: {
        label: 'Date Submitted',
        type: 'text',
        width: 110
      },
      Completed: {
        label: 'Date Scanned',
        type: 'text',
        width: 110
      }
    }

    return model
  }
}

function getAttachmentPDF(params) {
  if (params && params.data && params.data.AttachmentURL) {
    params.node.uri = params.colDef.uri = params.data.AttachmentURL

    params.value = params.data.MediaCode
    params.newTab = true

    return gotoCustom.template(params)
  } else {
    return ''
  }
}

function getInvoiceNumberPDFLink(params) {
  if (params && params.data && params.data.ScannedInvoicePDFURL) {
    params.node.uri = params.colDef.uri = params.data.ScannedInvoicePDFURL
    params.value = params.data.InvoiceNumber
    params.newTab = true

    return gotoCustom.template(params)
  } else {
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/components/_modules/InvoiceScan/models/scan-invoice-history-model.js